<script lang="ts">
  import { Control, setupControl } from "./controls";
  import FormField from "./FormField.svelte";
  import { Validator, type ValidatorMessages } from "./validators";
  import type { ControlValidator, ValidatorResult } from "./validators";

  export let placeholder: string = "";

  // either set name and validators
  export let name: string = null;
  export let required: boolean = false;
  export let validators: ControlValidator[] = [];
  export let value: any = undefined;
  // ... or bind a control
  export let control: Control = null;
  export let standalone: boolean = false;
  export let displayName: string = undefined;
  export let errors: ValidatorMessages = undefined;

  export let small: boolean = false;

  let input: HTMLSelectElement;
  function inputValidator(control: Control): ValidatorResult {
    if (input && "checkValidity" in input && !input.checkValidity()) {
      return {
        validator: "inputValidator",
        message: input.validationMessage,
      };
    }
  }

  const changes = setupControl(Control, {
    name,
    validators: [...validators, ...(required ? [Validator.required] : []), inputValidator],
    value,
    control,
    standalone,
  });
  $: ctrl = $changes;
  $: empty = ctrl.value === undefined;

  let oldValue = value;
  $: if (value !== oldValue) {
    oldValue = value;
    ctrl.value = value;
  }
</script>

<FormField bind:control={ctrl} displayName={displayName || placeholder} {errors} {standalone} on:change>
  <div class="input-control-label">
    <select
      bind:this={input}
      class="input-control"
      class:empty
      class:input-control-sm={small}
      class:input-error={ctrl.invalid}
      class:input-valid={ctrl.valid}
      class:input-dirty={ctrl.dirty}
      {name}
      on:blur
      value={`${ctrl.value}`}
      on:input={(_) => {
        ctrl.value = _.target["value"];
        ctrl.touch();
      }}
      {placeholder}
    >
      <slot control={ctrl} />
    </select>
    <div class="control-label">
      <slot name="label">
        {placeholder}{#if required}&nbsp;*{/if}
      </slot>
    </div>
  </div>
</FormField>

<style lang="scss" global>
  select.input-control {
    cursor: pointer;
    background-color: #f7f7f7;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='21.4' height='12.1' viewBox='0 0 21.4 12.1'%3E%3Cpath fill='none' stroke='%239f9f9f' stroke-width='2' d='m20.7.7-10 10L.7.7'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: calc(100% - 1em) 50%;
    background-size: 1.2em 1em;
    padding-right: 2.5em;
    padding-top: 0.8em;
    padding-bottom: 0.8em;

    &:hover {
      background-color: darken(#f7f7f7, 2%);
    }
  }

  select.input-control.input-control-sm {
    background-position: calc(100% - 0.5em) 50%;
    padding-top: 0.175rem;
    padding-bottom: 0.175rem;
  }
</style>
